import { message } from 'antd';
import { Toast } from 'antd-mobile';
export const notifyError = (msg) => {
    const text = msg || '操作失败';
    // ⭐ 判断是否移动端
    const isMobile = window.innerWidth <= 768 ||
        navigator.userAgent.includes('Mobile');
    if (isMobile) {
        Toast.show({ content: text });
    }
    else {
        message.error(text);
    }
};
